// all time fields are in seconds
import { isEqual } from 'lodash';

export interface ICaptionsItemWord {
  text: string,
  time: number,
  startLetterIndex?: number,
  endLetterIndex?: number
}

export interface ICaptionsItem {
  startTime: number;
  endTime: number;
  duration: number;
  text: string;
  words?: ICaptionsItemWord[]
  userName?: string;
  userId?: number;
}

export interface IComment {
  title: string;
  text: string;
  start: number;
  end: number;
}
export type TNewComment = Omit<IComment, 'id'>;

export interface IYoutubeVideoInfo {
  title: string;
  description: string;
  thumbnailUrl: string;
  thumbnailMediumUrl?: string;
  thumbnailStandardUrl?: string;
  channelId: string;
  channelTitle: string;
  defaultAudioLanguage?: string;
}

export interface IYoutubeVideoThumbnail {
  url: string;
  width: number;
  height: number;
}

export interface IYoutubeVideoInfoFull {
  publishedAt: string;
  channelId: string;
  title: string;
  description: string;
  thumbnails: {
      default: IYoutubeVideoThumbnail;
      medium: IYoutubeVideoThumbnail;
      high: IYoutubeVideoThumbnail;
      standard: IYoutubeVideoThumbnail;
      maxres: IYoutubeVideoThumbnail;
  },
  channelTitle: string;
  categoryId: string;
}

export enum PlayerStates {
  BUFFERING = 3,
  ENDED = 0,
  PAUSED = 2,
  PLAYING = 1,
  UNSTARTED = -1,
  VIDEO_CUED = 5,
}

export enum AudioPlayerStates {
  PAUSED = 2,
  PLAYING = 1,
}

export const LANG_CODE_AUTO_GEN_SUBSTR = '_autogen';



export interface IHocPropsCacheStore<T> {
  cache?: T
}

export const hocPropsCache = <T>(value: T, cacheStore: IHocPropsCacheStore<T>):T => {
  if (cacheStore.cache && isEqual(value, cacheStore.cache)) {
    return cacheStore.cache;
  }
  cacheStore.cache = value;
  return value;
}

export enum ERecentTab {
  ALL_LANGUAGES = 0,
  CURRENT_LANGUAGE = 1,
}

export type TVoicesMap = Record<string, SpeechSynthesisVoice[]>;
